import {createErrorAction} from './utils';

const TYPES = {
    GET_REWARDS: 'GET_REWARDS',
    GET_REWARDS_COMPLETE: 'GET_REWARDS_COMPLETE',
    GET_REWARDS_FAILED: 'GET_REWARDS_FAILED'
};

export default {
    TYPES,

    getRewards: payload => ({
        type: TYPES.GET_REWARDS,
        payload
    }),

    getRewardsSuccess: payload => ({
        type: TYPES.GET_REWARDS_COMPLETE,
        payload
    }),

    getRewardsFailed: createErrorAction(TYPES.GET_REWARDS_FAILED)
};
